import { Navigate } from 'react-router-dom'
import { MainPage } from '../features/main/mainPage.tsx'
import { useAppModule } from '../features/appContext.ts'
import { urls } from '../shared/urls.ts'

export function StartPage() {
  const { appStorage } = useAppModule()
  const currentCourse = appStorage.get('currentCourse')
  if (!currentCourse) {
    return <Navigate to={urls.myCourses} replace />
  }
  return <MainPage />
}
